module.exports = __webpack_public_path__ + "assets/img/truly-bug-icon.78e4e631.svg";